/**
 * Player scene
 * 
 * @author Mautilus s.r.o.
 * @class Scene_Player
 * @extends Scene
 */

Scene_Player = (function(Scene) {

	var Scene_Player = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Scene_Player.prototype, Scene.prototype, {
		/**
		 * @inheritdoc Scene#init
		 */
		init: function() {
			var scope = this;

			// needed to save progress
			this.alreadyPlayedSeconds = 0;
			
			this.model = {};      // movie (model Asset)
			this.settings = {};   // playback settings

			// amount of ms used when ff or rew
			this.skip = '2%'; // 2%
			this.altSkip = 1200000;	// 10 seconds
			this.playbackStartEvent = false;
			
			// Player UI snippet
			this.playerUISnip = new Snippet_PlayerUI(this, {});
			this.playerUISnip.on("focus:out", this.onFocusOut, this);

			this.logInterval = null;

			this.errorDialog = null;

			this.saveTimeouts = null;

			// bind player events
			this.bindPlayer();
			
			this.on('beforekey', this.onKeyBefore, this);
			
			this.$el.bind('click', function(){
				scope.playerUISnip.showPlayerUI();
			});
		},

		bindPlayer: function() {
			Player.on('statechange', this.onStateChange, this);

			Player.on('playbackstart', function() {  // only for Samsung
				console.log("[Scene_Player] playbackstart Samsung");
				if(this.isVisible) {
					this.playbackStartEvent = true;
          if (this.canHideThrobber)
            App.throbberHide(false);
				}
			}, this);
			
			Player.on('timeupdate', this.onTimeUpdate, this);
			
			Player.on('playbackspeed', function(speed){
				this.playerUISnip.updatePlaybackSpeed(speed);
			}, this);
			
			Player.on('end', function() {
				console.log('[Scene_Player] onEnd');
				//if (User.isLogged()) this.saveProgress(true);
				this.stop();
			}, this);

			Player.on('stop', function() {
				console.log('[Scene_Player] onStop');
				this.onStop();
			}, this);
			
			Player.on('durationchange', function(time) {
				console.log('[Scene_Player] onTime ' + time);
				this.playerUISnip.playerControlsSnip.updateDuration(time);
			}, this);
			
			Player.on('error', this.onError, this);
		},

		/**
		 * Clear listeners on player
		 */
		unbindPlayer: function() {
			Player.off('timeupdate');
			Player.off('statechange');
			Player.off('playbackstart');
			Player.off('playbackspeed');
			Player.off('durationchange');
			Player.off('error');
			Player.off('end');
		},
		
		/**
		 * Player's error event handler
		 * @param {Number} state
		 */
		onError: function (type, msg, detail) {
			msg = typeof (msg) === "string" ? msg : "";
			detail = typeof (detail) === "string" ? detail : "";
			console.log('[Scene_Player] onError, isVisible: ' + this.isVisible + ", errType: " + type + ", errMsg: " + msg);
			if (this.isVisible && App.networkStatus) {
				App.throbberHide(false);
				this.showErrDialog(type);
			}
		},

		/**
		 * Player's timeUpdate event handler
		 * @param {Number} state
		 */
    onTimeUpdate: function (time) { /*[ms]*/
      if (time > 0) {
        this.canHideThrobber = true;
        App.throbberHide();
      }
			if (this.isVisible) {
				if (Player.speed < 1 && Player.currentTime <= 3500) {  // [ms]
					this.setPlaybackSpeed(1, true);
				}

				if (Player.currentState === Player.STATE_PLAYING) {
					this.playerUISnip.playerProgressBarSnip.update(time, Player.duration);
					this.playerUISnip.playerControlsSnip.updateTime(time);
				}
			}
		},

		/**
		 * Player's stateChange event handler
		 * @param {Number} state
		 */
		onStateChange: function (state) {
			console.log('[Scene_Player] onStatechange: ' + state + ", visibility: " + this.isVisible);
			if (this.isVisible && App.networkStatus) {
				this.playerUISnip.showPlayerUI();
				this.playerUISnip.playerControlsSnip.updateButtons(state);   // update buttons

				if (state === Player.STATE_BUFFERING) {
					App.throbber(true);
				} else if (state === Player.STATE_PLAYING) {
					if (this.errorDialog) {
						this.errorDialog.destroy();
						this.errorDialog = null;
						this.focus();
					} else if (App.dialog) {
						App.dialog.destroy();
						this.focus();
					}
					if (!Device.isSAMSUNG || (Device.isSAMSUNG && this.playbackStartEvent)) {
            if (this.canHideThrobber) 
              App.throbberHide(false);
					}
				} else {
          if (this.canHideThrobber) 
            App.throbberHide(false);
				}
			}
		},

		/**
		 * @inheritdoc Scene#create
		 */
		create: function() {
			return $('#scene-player');
		},
		
		/*
		 * --------------------------------------------------------------
		 * Player go Activate
		 * --------------------------------------------------------------
		 */
		/**
		 * @inheritdoc Scene#activate
		 * @param {Object} movie (Asset Model)
		 * @param {Object} settings
		 * @param {string} settings.videoType - selected type of video ("trailer" or "movie")
		 * @param {Number} settings.seekTime (optional) - miliseconds
		 */
		activate: function(movie, settings) {
			return new Promise(function(resolve, reject) {
				this.bindPlayer();
				this.stopped = false;
				App.throbber(false);
        		this.canHideThrobber = false; // the tv reports buffering really unreliably so we check if we played at least one second before hiding throbber
				// if ( Device.isWEBOS ) {
				// 	Device.clearHistory();
				//   Device.pushHistory();
				// }
        		this.model = movie.attributes;
        		console.log(movie.attributes.id);
        		console.log(movie.attributes.video_url_mp4);
				//if(this.model.typeVideo === 'MAIN') {
				//	App.provider.getPlayerProgress(User.getUserId(), this.model.id)
				//		.bind(this)
				//		.then(function(resp) {
				//			var time = resp.data && resp.data[0] && resp.data[0].time ? resp.data[0].time : 0;
				//			var seekTime = parseInt(time);
				//			this.alreadyPlayedSeconds = seekTime;
				//			this.startPlay({ url: movie.attributes.video_url_mp4, seekTime: seekTime*1000});
				//			resolve();
				//		}, function(err){
				//			console.log(err);
				//			reject();
				//		})
				//} else {
					API.startPlayerProgress(movie.attributes.id);
					setTimeout(this.saveProgress(movie.attributes.id), 10000);
					this.startPlay({url: movie.attributes.video_url_mp4});
					if (this.canHideThrobber) App.throbberHide(false);
					resolve();
				//}
			}.bind(this)).catch(function(err) {
				console.log(err);
				if (this.canHideThrobber) App.throbberHide(false);
			});
		},
		
		/**
		 * To start play video
		 * @param {Object} settings
		 * @param {String} settings.url - stream URL
		 * @param {Number} settings.seekTime (optional) - miliseconds
		 */
		startPlay: function(settings) {
			console.log("[Scene_Player] startPlay");
			this.settings = settings || this.settings;
			// this.settings.url = 'http://akamai-progressive.irt.de/irt_hbbtv_5min/1080p25_libx264_high_7bar_6500k_gop50_libfdk_lc_384k_48k_2ch_eng.mp4';
			App.throbber();
			this.playerUISnip.render(this.model);
			this.playerUISnip.focus();
			
			// play			
			this.play(this.settings.url, this.settings.seekTime);
		},
		
		/**
		 * @inheritdoc Scene#render
		 */
		render: function() {
		},
		
		/**
		 * To clear
		 */
		clear: function() {
			this.unbindPlayer();
			Player.reset();
			this.playerUISnip.hidePlayerUI();
			this.playerUISnip.playerMovieInfoSnip.hide();
			this.playerUISnip.clear(true);
		},
		
		/**
		 * @inheritdoc Scene#refresh
		 */
		refresh: function(data) {
			if(Player.currentState !== Player.STATE_PENDING) { 
				this.stop();
			}
			console.log('refresh');
			this.activate.apply(this, data);
		},
		
		/*
		 * --------------------------------------------------------------
		 * Player Dialogs
		 * --------------------------------------------------------------
		 */
		/**
		 * Show Error Dialog for Player
		 * @param {String} error type
		 */
		showErrDialog: function(errType, event) {
			var msg = "";
			console.log("showErrDialog, type: " +errType);
			switch(errType) {
				case "noURL": 
					msg = __('no_url');
					break;
				default: 
					msg = __('playback_error_message');
					break;
			}
			var dialog = new Snippet_Dialog_error(null, {'selector': 'dialog-error'});
			dialog.setButtons([{ cls: '', action: 'callback', label: 'ok' }]);
			dialog.setCallback(this.onStop.bind(this));
			dialog.title = __('player_error');
			dialog.message = msg || '';
			dialog.render();
			dialog.focus();
			this.errorDialog = dialog;
		},
		
		/*
		 * --------------------------------------------------------------
		 * Player controls
		 * --------------------------------------------------------------
		 */
		/**
		 * PLAY video player
		 * @param {String} url (optional)
		 * @param {Number} position (optional) - initial seek [miliseconds]
		 */
		play: function( url, position ) {
			if ( this.playerUISnip.playerControlsSnip.currentSpeed !== 1 ) {
				Subtitles.$el.empty();
				this.playerUISnip.playerControlsSnip.hideSpeed();
				this.playerUISnip.playerProgressBarSnip.hideFastSeeking();
				var position = this.playerUISnip.playerProgressBarSnip.timeScrubber;
				this.seek(position, true);
			}
			if ( Player.speed !== 1 ) {
				Player.playbackSpeed( 1 );
			} else {
				// fix for Samsung Orsay - you can hear sound but not see video
				// TODO: consider using it without device checking to prevent errors on various devices
				if ( Device.isSAMSUNG ) {
					Player.$el.css( {
						width: '1280px',
						height: '720px'
					} );
				}
				console.log('[PositioN]: ' + position);

        Player.play( url, position );
			}
		},
		
		/**
		 * PAUSE video player
		 */
		pause: function() {
			if(Player.currentState === Player.STATE_PLAYING && Player.currentTime > 500) {  // 500ms due to problem on Samsung
				Player.pause();
			}
		},
		
		/**
		 * STOP video player
		 */
		stop: function() {
			Player.stop();
		},
		
		/**
		 * SEEK video player
		 * @param {Number} - seek position [ms]
		 * @param {Boolean} [ignorePause=false] - for true it will ignore the pause state and it starts to play and do a seek
		 */
		seek: function( position, ignorePause ) {
			if ( Player.currentState === Player.STATE_PLAYING && Player.currentTime > 500 ) {
				Player.seek( position );
				return true;
			} else if ( ignorePause && Player.currentState === Player.STATE_PAUSED && Player.currentTime > 500 ) {
				this.play();
				Player.seek( position );
				return true;
			}
			return false;
		},
		
		/**
		 * FF video player (fast seeking)
		 */
		ff: function() {
			var isAlternateNeeded = Device.isLG || Device.isWEBOS;
			var skipRate = (isAlternateNeeded && this.model.typeVideo != 'MAIN') ? this.altSkip : this.skip;	// TETEXT-21
			Player.forward(skipRate);
		},
		
		/**
		 * RW video player (fast seeking)
		 */
		rw: function() {
			var isAlternateNeeded = Device.isLG || Device.isWEBOS;
			var skipRate = (isAlternateNeeded && this.model.typeVideo != 'MAIN') ? this.altSkip : this.skip;	// TETEXT-21
			Player.backward(skipRate);
		},

		/**
		 * FULLSCREEN video player
		 */
		fullscreen: function() {
			Player.fullscreen();
		},

		/*
		 * --------------------------------------------------------------
		 * Scene events
		 * --------------------------------------------------------------
		 */
		/**
		 * @inheritdoc Scene#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},

		saveProgress: function(videoID) {
			console.log('SAVE PROGRESS: ' + videoID);
			if(Player.currentState === Player.STATE_PLAYING){
				seconds = Math.floor(Player.currentTime / 1000) - this.alreadyPlayedSeconds;
				console.log('[SecondS] ' + seconds);
				API.savePlayerProgress(videoID, seconds);
			}
			//setTimeout(this.saveProgress.bind(this), 10000);
			this.saveTimeouts = setTimeout(function() { this.saveProgress(videoID); }.bind(this), 10000);
				
			/*var config = {
				userID: User.getUserId(),
				playID: this.model.play_id,
				seconds: seconds
			}
			App.provider.savePlayerProgress(config).then(function(data) {
				console.log(JSON.stringify(data));
			});*/
		},

		/**
		 * @inheritdoc Scene#onEnter
		 */
		onEnter: function($el, event) {
		},
		/**
		 * @inheritdoc Scene#onReturn
		 */
		onReturn: function($el, event, stop) {
			stop && stop();
			if(App.dialog) {
				App.dialog.onClose();
				return;
			}
			
			if(this.playerUISnip.playerProgressBarSnip.$scrubber.hasClass("active")){
				this.playerUISnip.playerProgressBarSnip.$scrubber.removeClass("active");
			} else if(this.playerUISnip.isVisiblePlayerUI()) {
				this.playerUISnip.hidePlayerUI();
			} else {
				//if (User.isLogged()) this.saveProgress();
				App.throbber();
				this.stop();
			}
			return false;
		},
		
		onStop: function() {
			if (this.stopped) return false; 
			this.clear();
			clearTimeout(this.saveTimeouts);
			this.stopped = true;
			Router.goBack();
		},

		/**
		 * @inheritdoc Scene#navigate
		 */
		navigate: function(direction) {
		},
		
		onKeyBefore: function(keyCode) {
			if(App.dialog) {
				return true;
			}
			
			var validKeys = [Control.key.LEFT, Control.key.RIGHT, Control.key.UP, Control.key.ENTER, Control.key.KEY_PLAY_PAUSE];
			if(validKeys.indexOf(keyCode) > -1) {
				if(!this.playerUISnip.isVisiblePlayerUI()) {
					this.playerUISnip.showPlayerUI();
					return false;
				} else {
					this.playerUISnip.showPlayerUI();
				}
			}
			
			switch(keyCode){
				case Control.key.PLAY_PAUSE:
				console.warn('HITTING THE SpOT!');
					this.playerUISnip.playerControlsSnip.handlePlayPause();
					return false;
				case Control.key.PLAY:
					if(this.playerUISnip.playerProgressBarSnip.$scrubber.hasClass("active")) {
						this.playerUISnip.playerProgressBarSnip.$scrubber.removeClass("active");
					}
					this.playerUISnip.showPlayerUI();
					var pauseValid = (Player.currentState === Player.STATE_PAUSED && Player.currentTime > 0);
					var speedValid = (Player.currentState === Player.STATE_PLAYING && Player.speed != 1);
					if(pauseValid || speedValid) {
						this.play();
					}
					return false;
				case Control.key.PAUSE:
					if(this.playerUISnip.playerProgressBarSnip.$scrubber.hasClass("active")) {
						this.playerUISnip.playerProgressBarSnip.$scrubber.removeClass("active");
					}
					this.playerUISnip.showPlayerUI();
					this.pause();
					return false;
				case Control.key.FF:
					if (Player.currentState === Player.STATE_PLAYING || (Player.currentState === Player.STATE_PAUSED && this.playerUISnip.playerControlsSnip.currentSpeed !== 1)) {
						if(!this.playerUISnip.playerProgressBarSnip.$scrubber.hasClass("active")) {
							this.playerUISnip.playerProgressBarSnip.$scrubber.addClass("active");
						}
                        this.ff();
                    }
					return false;
				case Control.key.RW:
					if (Player.currentState === Player.STATE_PLAYING || (Player.currentState === Player.STATE_PAUSED && this.playerUISnip.playerControlsSnip.currentSpeed !== 1)) {
						if(!this.playerUISnip.playerProgressBarSnip.$scrubber.hasClass("active")) {
							this.playerUISnip.playerProgressBarSnip.$scrubber.addClass("active");
						}
                        this.rw();
                    }
					return false;
				case Control.key.STOP:
					this.stop();
					return false;
				default: return true;
			}
		},
		
		/**
		 * @inheritdoc Scene#focus
		 */
		focus: function() {
			if(App.dialog) { 
				return;
			}
			
			return this.playerUISnip.focus();
		},
		
		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Scene
		 * 
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
		onFocusOut: function (snippet, direction) {
		}
	});

	return Scene_Player;

})(Scene);


//////////////////
// WEBPACK FOOTER
// ./js/scene/player.js
// module id = 56
// module chunks = 0